import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { useIntl, defineMessages } from "react-intl";
import { Typography } from "@material-ui/core";

import { Divider, List, ListItem } from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";
import { FormattedMessage } from "react-intl";

import HeaderPopup, { useHeaderPopupStyles } from "./headerPopup";
import { setLocaleLang } from "../../../redux/domain/domainActions";
import * as LoginActions from "../../../redux/login/loginActions";
import AccountIcon from "../../common/icons/accountIcon";
import LanguageIcon from "../../common/icons/languageIcon";
import LogoutIcon from "../../common/icons/logoutIcon";
import { requestTasks, requestTasksSucceeded } from "../../../redux/task/taskActions";
import Cookies from "universal-cookie";

const messages = defineMessages({
    profileTooltip: {
        id: "main-header.profile-tooltip",
        defaultMessage: "Profile",
        description: "Profile main header toottip",
    },
});

const useStyles = makeStyles((theme) => ({
    profileName: {
        color: "var(--text-dark)",

        fontFamily: "Arial",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: "700",
        lineHeight: "16px",
        letterSpacing: "-0.025em",
        textAlign: "left",

        display: "block",
    },
    profileId: {
        color: "var(--text-dark)",

        fontFamily: "Arial",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "16px",
        letterSpacing: "-0.025em",
        textAlign: "left",

        display: "block",
    },
}));

export const Profile = ({ lang, userProfile, counts, userInfo, tasks, setLocaleLang, requestTasks, logout }) => {
    const classes = useStyles();
    const popupClasses = useHeaderPopupStyles();
    const intl = useIntl();
    const history = useHistory();
    const cookies = new Cookies();
    // const availableTasks = {
    //     fetching: false,
    //     tasks: tasks,
    //     counts: counts
    // }
    const changeLanguage = (lang) => {
        setLocaleLang(lang);
        cookies.set("locale", lang);
        //requestTasks();
    };

    return (
        <HeaderPopup
            id="user-profile"
            icon={(open) => <AccountIcon color={open ? "var(--blue-bell)" : "white"} title={intl.formatMessage(messages.profileTooltip)} />}>
            <List aria-label="profile details">
                <ListItem>
                    <div>
                        <Typography className={classes.profileName}>{`${userProfile?.firstName || ""} ${userProfile?.firstName || ""}`}</Typography>
                        <Typography className={classes.profileId}></Typography> {/* we have no profile ID with the profile at the moment */}
                    </div>
                </ListItem>
                <Divider />
                {process.env.REACT_APP_FEATURE_TRANSLATION === "true" && (
                    <ListItem>
                        <button className={popupClasses.linkButton} type="button" onClick={() => changeLanguage(lang === "fr" ? "en" : "fr")}>
                            <LanguageIcon className={popupClasses.icon} lang={lang === "fr" ? "en" : "fr"} />
                            <FormattedMessage
                                id="profile.select-language"
                                description="profile: select language"
                                defaultMessage="Changer la langue pour Français"
                            />
                        </button>
                    </ListItem>
                )}
                <ListItem>
                    <button
                        className={popupClasses.linkButton}
                        type="button"
                        onClick={() => {
                            history.push("/");
                            logout();
                        }} // Handles redirecting when signing back in
                    >
                        <LogoutIcon className={popupClasses.icon} />
                        <FormattedMessage id="profile.logout" description="profile: logout" defaultMessage="Log out" />
                    </button>
                </ListItem>
            </List>
        </HeaderPopup>
    );
};

const mapStateToProps = (state) => ({
    lang: state.domain.locale.lang,
    userProfile: state.login.userProfile,
    userInfo: state.login.userInfo,
    // tasks:state.tasks.tasks,
    // counts:state.tasks.counts
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setLocaleLang,
            logout: LoginActions.logout,
            requestTasks,
            // requestTasksSucceeded
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
